/* Bahar Art Creations · Recently Viewed Products
   Stores up to 8 viewed products in localStorage.
   Reads them back and renders a horizontal scroll row. */

(function() {
  var STORAGE_KEY = 'bac_rv';
  var MAX_STORE   = 8;

  /* ---- localStorage helpers ---- */
  function getItems() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch(e) { return []; }
  }

  function saveItem(item) {
    var items = getItems().filter(function(i) { return i.handle !== item.handle; });
    items.unshift(item);
    if (items.length > MAX_STORE) items = items.slice(0, MAX_STORE);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch(e) {}
  }

  /* ---- Record current product (product pages only) ---- */
  var dataEl = document.getElementById('rv-product-data');
  var currentHandle = '';

  if (dataEl) {
    try {
      var product = JSON.parse(dataEl.textContent || '{}');
      if (product && product.handle) {
        currentHandle = product.handle;
        saveItem(product);
      }
    } catch(e) {}
  }

  /* ---- Render ---- */
  var section = document.getElementById('rv-section');
  var track   = document.getElementById('rv-track');
  if (!section || !track) return;

  var maxShow = parseInt(section.getAttribute('data-max') || '6', 10);
  var items   = getItems()
                  .filter(function(i) { return i.handle !== currentHandle; })
                  .slice(0, maxShow);

  if (items.length === 0) {
    section.hidden = true;
    return;
  }

  track.innerHTML = items.map(function(item) {
    var imgTag = item.image
      ? '<img src="' + item.image + '" alt="' + escHtml(item.title) + '" loading="lazy" width="400">'
      : '';
    var price = item.price_str
      ? '<p class="rv-card__price">' + escHtml(item.price_str) + '</p>'
      : '';
    return '<a href="' + escHtml(item.url) + '" class="rv-card">' +
             '<div class="rv-card__image">' + imgTag + '</div>' +
             '<p class="rv-card__title">' + escHtml(item.title) + '</p>' +
             price +
           '</a>';
  }).join('');

  /* ---- Nav arrows (desktop only) ---- */
  var prevBtn = document.getElementById('rv-prev');
  var nextBtn = document.getElementById('rv-next');
  if (prevBtn && nextBtn) {
    var cardWidth = track.querySelector('.rv-card');
    prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -(cardWidth ? cardWidth.offsetWidth + 20 : 280), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function() {
      track.scrollBy({ left: cardWidth ? cardWidth.offsetWidth + 20 : 280, behavior: 'smooth' });
    });
  }

  function escHtml(str) {
    if (typeof str !== 'string') return '';
    return str.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
})();
